import React from 'react';
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import * as API from '../../appAPI/api';
import { randomID } from '../../helper_functions/helper_functions';

const ClientsPage = ({handleCurrentPage, handleClientInfo}) => {
  const [data, setData] = useState([])
  const [copyOfdata, setCopyOfData] = useState([])
  const [saveButton, setSaveButton] = useState([]);
  const [error, setError] = useState('');

  useEffect(() => {
    (async () => {
      const getData = await API.getClientsData();
      setData(getData.clients)
      setCopyOfData(getData.clients)
    })()
  }, [])

  const handleSearch = (num) => {
    if (/01[0-9]{9}$/.test(num.value)) {
      setCopyOfData(data.filter((x) => x.number === num.value))
    }else if (num.value === '') {
      setCopyOfData(data)
    }
  }

  const handleSave = (x, type, number) => {
    let num = x.parentElement.parentElement.firstElementChild.firstElementChild.value;
    let info = x.parentElement.parentElement.children[1].firstElementChild.value;
    let newSaveBtn = [...saveButton];

    switch (type) {
      case 'change':
        
        if (/01[0-9]{9}$/.test(num) && info !== '' && !newSaveBtn.includes(number)) {
          newSaveBtn.push(number);
          setSaveButton(newSaveBtn)
        }else if ((!/01[0-9]{9}$/.test(num) || info === '' )&& newSaveBtn.includes(number)){
          newSaveBtn = newSaveBtn.filter((x) => x !== number)
          setSaveButton(newSaveBtn)
        }
        break;
      case 'saveChange': 
        newSaveBtn = newSaveBtn.filter((x) => x !== number)
        setSaveButton(newSaveBtn);
        let newData = [...data].map((d) => {
          if (d.id === number) {
            d.number = num;
            d.info = info;
          }
          return d;
        })

        let newCopyOfData = [...data].map((d) => {
          if (d.id === number) {
            d.number = num;
            d.info = info;
          }
          return d;
        })

        setCopyOfData(newCopyOfData)
        setData(newData)
        API.updateClientsData(newData)
        handleClientInfo(newData)
      break;
      default:
    }
  }
  const addClient = (e) => {
    e.preventDefault();
    let num = document.getElementById('numData');
    let info = document.getElementById('infoData');

    let newData = [...data]
    let newCopyOfData = [...data];
    for (let x of newData) {
      if (x.number === num.value) {
        setError('This Number is already add');
        return;
      }
    }
    setError('');
    newCopyOfData.unshift({number: num.value, info: info.value, id: randomID()})
    newData.unshift({number: num.value, info: info.value, id: randomID()})
    setCopyOfData(newCopyOfData)
    setData(newData)
    num.value = '';
    info.value = '';
    API.updateClientsData(newData)
    handleClientInfo(newData)
  }

  return (
    <section className="employees-page clients-page">
      <section className="admin-page-links">
        <Link to='/delivery-assistant/' className="back-arrow" title="orders page">⟰</Link>
        <p>/</p>
        <button onClick={() => handleCurrentPage('adminHomePage')}>Admin_Page</button>
      </section>
      <h1>Clients Data </h1>
      <section className="search-bar">
        <p>Search</p>
        <input 
          type='search' 
          name='search' 
          placeholder="number" 
          onChange={(e) => handleSearch(e.target)}
        />
      </section>
      <section className="table-data">
        <table>
          <thead>
            <tr>
              <th>Number</th>
              <th>Data</th>
              <th></th>
            </tr>
          </thead>
        <tbody>
          {copyOfdata && copyOfdata.map((d) => (
            <tr key={d.id}>
              <td>
                <input 
                 type='tel'
                 defaultValue={d.number}
                 onChange={(e) => handleSave(e.target,'change', d.id)}
                 />
              </td>
              <td>
                <textarea 
                  defaultValue={d.info}
                  onChange={(e) => handleSave(e.target,'change', d.id)}
                ></textarea>
              </td>
              <td>
                {saveButton.includes(d.id) && 
                  <button onClick={(e) => handleSave(e.target,'saveChange', d.id)}>Save</button>
                }
              </td>
            </tr>
          ))}
        </tbody>

        <tfoot>
          <tr>
            <td colSpan='3'>{copyOfdata.length}</td>
          </tr>
        </tfoot>
        </table>
      </section>
      <form className="search-bar add-client" onSubmit={(e) => addClient(e)}>
      { error && <p className="massage-error">{error}</p>}
      
        <input 
          type='search' 
          name='search' 
          placeholder="number" 
          required
          pattern="01[0-9]{9}$"
          id='numData'
        />
        <textarea 
          required
          placeholder="add the new number data"
          id='infoData'
          ></textarea>
        <button>Add</button>
      </form>
    </section>
  )
}

export default ClientsPage;